import { IColumnHeader } from '@aon/aon-tws-common-ui';
import { IsDefined, NameOf } from '../../utilities/GroupAccessOwners/CommonUtil';
import { IGroupAccessOwnerRowData } from './GroupAccessOwnerRow';
import { IQueryDataField } from './ServiceInterfaces';

export interface IGroupAccessOwnerColumnSelectable extends IGroupAccessOwnerColumn {
	asSelectable: {
		selectedByDefault?: true;
		selectionLocked?: true;
	};
}

export function IsOwnerColumnSelectable(col: IGroupAccessOwnerColumn): col is IGroupAccessOwnerColumnSelectable {
	return IsDefined(col) && NameOf<IGroupAccessOwnerColumnSelectable>('asSelectable') in col;
}

export function MakeSelectable<T extends IGroupAccessOwnerColumn>(
	column: T,
	selectionOptions: IGroupAccessOwnerColumnSelectable['asSelectable'],
): T & IGroupAccessOwnerColumnSelectable {
	return {
		...column,

		asSelectable: {
			...selectionOptions,
		},
	};
}

export interface IGroupAccessOwnerColumnQueryable extends IGroupAccessOwnerColumn {
	asQueryable: IQueryDataField;
}

export function IsOwnerColumnQueryable(col: IGroupAccessOwnerColumn): col is IGroupAccessOwnerColumnQueryable {
	const asQueryable = (col as IGroupAccessOwnerColumnQueryable)?.asQueryable;

	return (
		IsDefined(asQueryable) &&
		NameOf<IGroupAccessOwnerColumnQueryable['asQueryable']>('fieldName') in asQueryable &&
		NameOf<IGroupAccessOwnerColumnQueryable['asQueryable']>('boundToEntity') in asQueryable
	);
}

export interface IGroupAccessOwnerColumn {
	header: IColumnHeader;
	render: {
		cellData(row: IGroupAccessOwnerRowData): any;
	};
}
